import { Inject, Injectable } from '@angular/core';
import { HostPlatformService } from '@shared/services/host-platform.service';
import { IS_DUE_DATE_VISIBLE$ } from '@shared/services/sections-visibility.tokens';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { Observable } from 'rxjs';

@Injectable()
export class GeneralRxDataV1Facade {
	rx$ = this.shellQuery.rx$;
	rxConfiguration$ = this.shellQuery.rxConfiguration$;
	dateFormat$: Observable<string> = this.shellQuery.dateFormat$;
	isRxForModelingContext$: Observable<boolean> = this.hostPlatformService.isIteroModeling$;
	isDueDateVisible$: Observable<boolean> = this.isDueDateVisibleToken$;

	constructor(
		private readonly shellQuery: ShellQuery,
		private readonly hostPlatformService: HostPlatformService,
		@Inject(IS_DUE_DATE_VISIBLE$) private readonly isDueDateVisibleToken$: Observable<boolean>
	) {}
}
